exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */[dir] .cancel-res-button{padding:15px 15px;border:1px solid #97999b;cursor:pointer}.disabled-button{opacity:.5}[dir] .disabled-button{cursor:default}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/cancel-res-button/cancel-res-button.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/cancel-res-button/cancel-res-button.component.scss
// module chunks = 0